export default {
  alreadyExist: 'Item with these name already exist',
  loading: 'Loading...',
};
